import CardSystem from '../CardSystem';
import Renderable from '../../../Component/Renderable';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import GameObject from '../../../GameObject/GameObject';
import { PlaySound } from '../../Audio/AudioHelper';
import { AudioTrackType } from '../../Audio/AudioClip';
import CardAnimationTask from '../../../Utility/Task/CardAnimationTask';
import Interactable from '../../../Component/Interactable';
import Animator from '../../../Prototype/Animator';
import { UIEvent } from '../../UI/BaseUISystem';
import { ICardStateTaskData } from '../../../State/Card/ICardState';

export default function PlusThreeCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    system.scene.emit(UIEvent.DISABLE_INTERACTIVITY, false);
    const sourceCard = system.getCardByID(taskData.cards[0]);
    sourceCard.score = taskData.cardsScore[0];

    // Hide source card.
    sourceCard.getComponent(Renderable).visible = false;
    sourceCard.getComponent(Interactable).enabled = false;

    const plusThreeAnimator = GameObject.Instantiate(Animator);
    system.animator.addChild(plusThreeAnimator);

    const targetCards: BaseCard[] = [];
    for (let i = 1; i < taskData.cards.length; i++) {
        const card: BaseCard = system.getCardByID(taskData.cards[i]);
        card.score = taskData.cardsScore[i];
        targetCards.push(card);

        // Hide target cards until effect complete.
        card.getComponent(Renderable).visible = false;
        card.getComponent(Interactable).enabled = false;
        plusThreeAnimator.addChild(card);
    }

    const task = new CardAnimationTask(
        taskData,
        system,
        'CardPlusThree',
        plusThreeAnimator,
        {
            system,
            sourceCard: sourceCard,
            targetCards: targetCards,
            cardsContainer: system.cardsContainer,
            stackContainer: system.stackContainer,
        },
        true
    );

    task.animationClip.on('PlusThreeCardAdded', (card, i) => {
        PlaySound('booster-five-cards-use');
        system.cardStack.align();
    });
    system.taskQueue.queueNext(task);
}
